module.exports = __webpack_public_path__ + "static/media/arrow-down.715aa5f1.svg";